// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__16823","title":"Header_title__PN6Ib","side":"Header_side__3jqyr"};